import {Route, Routes, Outlet} from 'react-router-dom'
import {JudiListWrapper} from './judi-list/JudiList'

const JudiPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path='' element={<JudiListWrapper />} />
      </Route>
    </Routes>
  )
}

export default JudiPage
